import React, { PropTypes, PureComponent } from 'react';
import { OnClickOut } from 'react-fast-ui';

export default class DelayedOnClickOut extends PureComponent {
  static propTypes = {
    ...OnClickOut.propTypes,
    delay: PropTypes.number
  };

  static defaultProps = {
    delay: 1
  };

  componentDidMount() {
    setTimeout(() => this._listening = true, this.props.delay);
  }

  handleClickOut = (...args) => {
    if (!this._listening) {
      return;
    }

    this.props.onClickOut(...args);
  };

  render() {
    return <OnClickOut {...this.props} onClickOut={this.handleClickOut}/>;
  }
}



// WEBPACK FOOTER //
// ./src/js/components/DelayedOnClickOut.jsx